import Constants from '../../constants';
import { ACTION_FETCHING, ACTION_SUCCESS, ACTION_ERROR } from '../../constants/action-status';
import { Map } from 'immutable';

const DEFAULT_STATE = Map({
	isFetching: false,
	hasFetched: false,
});

export default function questionListPageReducer(state = DEFAULT_STATE, action) {
	switch (action.type) {
		case `${Constants.FETCH_QUESTION_LIST}_${ACTION_FETCHING}`:
			return state.withMutations((state) => {
				state.set('isFetching', true);
			});
		case `${Constants.FETCH_QUESTION_LIST}_${ACTION_ERROR}`:
		case `${Constants.FETCH_QUESTION_LIST}_${ACTION_SUCCESS}`:
			return state.withMutations((state) => {
				state.set('hasFetched', true);
				state.set('isFetching', false);
			});
		default:
			return state;
	}
}
